/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MailSend02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { styled } from '@mui/material/styles';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Box, IconButton, TextField, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { NotificationManager } from 'react-notifications';
import MergeTagsDropdown from './MergeTagsDropdown';
import MUIModal from '../MUIModal/MUIModal';
// @ts-ignore
import { html as beautifyHtml } from 'js-beautify';
import debounce from 'lodash.debounce';
import { checkEventPermission } from 'src/common/utility/utility';
import { SEND_TEST_EMAIL, UNKNOWN_ERR } from 'src/constants/constant';
import {
  aiValidationWakeup,
  aiValidationValidateHtml,
  aiValidationGetDetails,
  aiValidationSaveIssuesFeedback,
} from 'src/services/aiValidationService';

interface TemplateEditorProps {
  onHtmlChange: (html: string) => void;
  onDirtyCheckChange?: (isDirty: boolean) => void;
  initialHtml?: string;
  onImageUpload?: () => void;
  editorRef?: React.MutableRefObject<any>;
  isEditPage?: boolean;
  onSendTestEmail?: () => void;
  templateIdentifier?: string;
  templateVersion?: number | string;
  templateName?: string;
}

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
  [`& .${tooltipClasses.arrow}`]: {
    display: 'none',
  },
}));

interface AIIssue {
  key?: string;
  issueKey?: string;
  category?: string;
  label?: string;
  description?: string;
  needs_followup?: boolean | null;
  location?: { tag?: string | null; start_line?: number | null; end_line?: number | null } | null;
  followup?: { text?: string; type?: string; options?: string[] | null; value?: string; Value?: string }[] | null;
}

const getFollowupStoredValue = (followup: { Value?: unknown; value?: unknown; response?: unknown } | null | undefined): string => {
  if (followup == null) return '';

  const raw =
    followup.Value ??
    followup.value ??
    followup.response ??
    '';

  if (typeof raw === 'string') return raw;
  if (raw == null) return '';
  return String(raw);
};

interface AISummary {
  total_issues?: number;
  followup_count?: number;
  categories?: Record<string, number>;
}

const NO_VALIDATION_DETAILS_MESSAGE = 'No validation details found for this template';
const NO_VALIDATION_DETAILS_MESSAGE_NORMALIZED = NO_VALIDATION_DETAILS_MESSAGE.toLowerCase();
const INVALID_WEBHOOK_OR_JOBID_MESSAGE = 'Webhook payload or JobId is invalid';
const INVALID_WEBHOOK_OR_JOBID_MESSAGE_NORMALIZED = INVALID_WEBHOOK_OR_JOBID_MESSAGE.toLowerCase();
const HTML_REQUIRED_MESSAGE = 'Html field is required';
const AI_PANEL_HIDDEN_FOLLOWUP_TEXTS = [
  'our team can review and update the image specification for you',
  'our team can review and update the view in browser link for you',
];
const AI_PANEL_SUPPRESSED_INSTRUCTION_PREFIX = 'our team can review and update the ';
const AI_PANEL_SUPPRESSED_INSTRUCTION_SUFFIX = ' for you';
const AI_PANEL_REMOVED_MESSAGE_REGEX = new RegExp(
  '\\s*Our team can review and update the[^.!?\\r\\n]*for you\\.?\\s*',
  'gi',
);

const normalizeForComparison = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/\.+$/g, '');

const isSuppressedFollowupItem = (followup: { text?: string; type?: string } | null | undefined): boolean => {
  if (followup == null) return false;
  const followupType = (followup.type ?? '').trim().toLowerCase();
  if (followupType !== 'instruction') return false;
  const normalizedText = normalizeForComparison(followup.text ?? '');
  const isExactSuppressedText = AI_PANEL_HIDDEN_FOLLOWUP_TEXTS.some((suppressedText) => suppressedText === normalizedText);
  const isPatternSuppressedText =
    normalizedText.startsWith(AI_PANEL_SUPPRESSED_INSTRUCTION_PREFIX) &&
    normalizedText.endsWith(AI_PANEL_SUPPRESSED_INSTRUCTION_SUFFIX);
  return isExactSuppressedText || isPatternSuppressedText;
};

const sanitizeAiPanelText = (value: string): string =>
  value
    .replace(AI_PANEL_REMOVED_MESSAGE_REGEX, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

const isNoValidationDetailsMessage = (value: unknown): boolean => {
  if (typeof value !== 'string') return false;
  const normalized = value.trim().toLowerCase();
  return normalized.includes(NO_VALIDATION_DETAILS_MESSAGE_NORMALIZED);
};

const isInvalidWebhookOrJobIdMessage = (value: unknown): boolean => {
  if (typeof value !== 'string') return false;
  const normalized = value.trim().toLowerCase();
  return normalized.includes(INVALID_WEBHOOK_OR_JOBID_MESSAGE_NORMALIZED);
};

const getErrorMessage = (err: unknown): string => {
  if (err instanceof Error && err.message.trim() !== '') {
    return err.message;
  }

  if (
    typeof err === 'object' &&
    err != null &&
    'response' in err &&
    typeof (err as { response?: { data?: { message?: string } } }).response?.data?.message === 'string'
  ) {
    return (err as { response?: { data?: { message?: string } } }).response?.data?.message ?? '';
  }

  return '';
};

const isTransientValidationDetailsError = (err: unknown): boolean => {
  const message = getErrorMessage(err);
  return isNoValidationDetailsMessage(message) || isInvalidWebhookOrJobIdMessage(message);
};

const friendlyOption = (opt: string): string => {
  if (opt === '__other__') return 'Other';
  return opt.charAt(0).toUpperCase() + opt.slice(1);
};

const getIssueLocationLabel = (location?: AIIssue['location']): string => {
  if (!location || Object.keys(location).length === 0) return 'Not available';

  const parts: string[] = [];

  if (location.tag) {
    parts.push(`<${location.tag}>`);
  }

  if (location.start_line != null && location.end_line != null) {
    parts.push(
      location.start_line === location.end_line
        ? `Line ${String(location.start_line)}`
        : `Lines ${String(location.start_line)}-${String(location.end_line)}`,
    );
  } else if (location.start_line != null) {
    parts.push(`Line ${String(location.start_line)}`);
  }

  return parts.length > 0 ? parts.join(' | ') : 'Not available';
};

const getCurrentLoggedInUserId = (): number => {
  try {
    const storedUser = localStorage.getItem('user');
    if (!storedUser) return 0;

    const parsedUser = JSON.parse(storedUser) as { id?: number | string };
    const id = Number(parsedUser?.id ?? 0);
    return Number.isFinite(id) ? id : 0;
  } catch {
    return 0;
  }
};

const AIResultsView: React.FC<{ details: any; templateUId: string; jobId: string; transactionId: string; onClosePanel: () => void }> = ({ details, templateUId, jobId, transactionId, onClosePanel }) => {
  const issues: AIIssue[] = Array.isArray(details?.issues) ? details.issues : [];
  const summary: AISummary = details?.summary && typeof details.summary === 'object' ? (details.summary as AISummary) : {};

  const groupedIssues = issues.reduce<Record<string, AIIssue[]>>((accumulator, issue) => {
    const normalizedCategory = issue.category?.trim();
    const category = normalizedCategory != null && normalizedCategory !== '' ? normalizedCategory : 'Other';
    if (!accumulator[category]) {
      accumulator[category] = [];
    }
    accumulator[category].push(issue);
    return accumulator;
  }, {});

  const categoryEntries = Object.entries(groupedIssues).filter(([, list]) => list.length > 0);
  const categorySignature = categoryEntries.map(([category, list]) => `${category}:${String(list.length)}`).join('|');

  const [openCategories, setOpenCategories] = useState<Record<string, boolean>>({});
  const [followupResponses, setFollowupResponses] = useState<Record<string, string>>({});
  const [isSavingFeedback, setIsSavingFeedback] = useState<boolean>(false);
  const [unsavedIssues, setUnsavedIssues] = useState<Record<string, boolean>>({});
  const categoryRefs = useRef<Record<string, HTMLDivElement | null>>({});

  useEffect(() => {
    setOpenCategories((prev) => {
      const nextState: Record<string, boolean> = {};
      let changed = Object.keys(prev).length !== categoryEntries.length;

      categoryEntries.forEach(([category], index) => {
        const nextValue = prev[category] ?? index === 0;
        nextState[category] = nextValue;
        if (!changed && prev[category] !== nextValue) {
          changed = true;
        }
      });

      return changed ? nextState : prev;
    });
  }, [categorySignature]);

  useEffect(() => {
    const initialResponses: Record<string, string> = {};

    categoryEntries.forEach(([category, list]) => {
      list.forEach((issue, index) => {
        const issueKey = `${category}-${issue.label ?? 'issue'}-${String(index)}`;

        if (!Array.isArray(issue.followup)) {
          return;
        }

        issue.followup.forEach((followup, followupIndex) => {
          const responseKey = `${issueKey}::${String(followupIndex)}`;
          const initialValue = getFollowupStoredValue(followup);

          if (initialValue !== '') {
            initialResponses[responseKey] = initialValue;
          }
        });
      });
    });

    setFollowupResponses(initialResponses);
  }, [details, categorySignature]);

  const toggleCategory = (cat: string): void => {
    const isCurrentlyOpen = openCategories[cat] !== false;
    setOpenCategories((prev) => ({ ...prev, [cat]: !prev[cat] }));
    if (!isCurrentlyOpen) {
      setTimeout(() => {
        categoryRefs.current[cat]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  };

  const handleFollowupChange = (responseKey: string, value: string): void => {
    setFollowupResponses((prev) => ({ ...prev, [responseKey]: value }));
    const issueKey = responseKey.substring(0, responseKey.lastIndexOf('::'));
    setUnsavedIssues((prev) => ({ ...prev, [issueKey]: true }));
  };

  const handleFixIssue = async (): Promise<void> => {
    if (isSavingFeedback) {
      return;
    }

    if (templateUId.trim() === '') {
      NotificationManager.error('Template identifier is missing. Unable to save feedback.', '', 5000);
      return;
    }

    if (jobId.trim() === '') {
      NotificationManager.error('Job ID is missing. Unable to save feedback.', '', 5000);
      return;
    }

    const issuesToSave = categoryEntries.flatMap(([category, list]) =>
      list.map((listIssue, index) => ({
        issueKey:
          (typeof listIssue.key === 'string' && listIssue.key.trim() !== ''
            ? listIssue.key
            : typeof listIssue.issueKey === 'string' && listIssue.issueKey.trim() !== ''
              ? listIssue.issueKey
              : `${category}-${listIssue.label ?? 'issue'}-${String(index)}`),
        issue: listIssue,
      })),
    );

    const summaryPayload = {
      total_issues: typeof summary.total_issues === 'number' ? summary.total_issues : issues.length,
      followup_count:
        typeof summary.followup_count === 'number'
          ? summary.followup_count
          : issues.filter((issue) => Array.isArray(issue.followup) && issue.followup.length > 0).length,
      categories: summary.categories && typeof summary.categories === 'object'
        ? summary.categories
        : Object.fromEntries(categoryEntries.map(([category, list]) => [category, list.length])),
      validators_success: typeof details?.summary?.validators_success === 'number' ? details.summary.validators_success : 0,
      validators_fail: typeof details?.summary?.validators_fail === 'number' ? details.summary.validators_fail : 0,
    };

    const issuesPayload = issuesToSave.map((item) => {
      const issueFollowups = Array.isArray(item.issue.followup)
        ? item.issue.followup
            .map((followup, index) => ({ followup, index }))
            .filter(({ followup }) => !isSuppressedFollowupItem(followup))
        : [];
      const normalizedLocation: { tag?: string; start_line?: number; end_line?: number } = {};
      if (typeof item.issue.location?.tag === 'string' && item.issue.location.tag.trim() !== '') {
        normalizedLocation.tag = item.issue.location.tag;
      }
      if (typeof item.issue.location?.start_line === 'number') {
        normalizedLocation.start_line = item.issue.location.start_line;
      }
      if (typeof item.issue.location?.end_line === 'number') {
        normalizedLocation.end_line = item.issue.location.end_line;
      }

      return {
        category: item.issue.category ?? '',
        label: item.issue.label ?? '',
        description: item.issue.description ?? '',
        needs_followup: item.issue.needs_followup ?? null,
        location: normalizedLocation,
        followup: issueFollowups.map(({ followup, index }) => {
          const responseKey = `${item.issueKey}::${String(index)}`;
          const existingFollowupValue = getFollowupStoredValue(followup);
          const hasUserEditedValue = Object.prototype.hasOwnProperty.call(followupResponses, responseKey);
          const followupItem: { text: string; type: string; options?: string[]; Value: string } = {
            text: followup.text ?? '',
            type: followup.type ?? '',
            Value: hasUserEditedValue ? followupResponses[responseKey] : existingFollowupValue,
          };

          if (Array.isArray(followup.options) && followup.options.length > 0) {
            followupItem.options = followup.options;
          }

          return followupItem;
        }),
      };
    });

    const detailsTransactionId =
      (typeof details?.transactionId === 'string' ? details.transactionId : '') ||
      (typeof details?.transaction_id === 'string' ? details.transaction_id : '') ||
      (typeof details?.data?.transactionId === 'string' ? details.data.transactionId : '') ||
      (typeof details?.data?.transaction_id === 'string' ? details.data.transaction_id : '') ||
      (typeof details?.result?.transactionId === 'string' ? details.result.transactionId : '') ||
      (typeof details?.result?.transaction_id === 'string' ? details.result.transaction_id : '') ||
      '';

    const resolvedTransactionId =
      (typeof transactionId === 'string' ? transactionId.trim() : '') ||
      detailsTransactionId ||
      jobId;

    setIsSavingFeedback(true);
    try {
      await aiValidationSaveIssuesFeedback({
        status: 'success',
        templateUId,
        jobId,
        data: {
          summary: summaryPayload,
          issues: issuesPayload,
        },
        transactionId: resolvedTransactionId,
      });
      setUnsavedIssues({});
      NotificationManager.success('Feedback saved successfully.', '', 5000);
    } catch (err: unknown) {
      const errorMessage = getErrorMessage(err) || 'Failed to save feedback.';
      NotificationManager.error(errorMessage, '', 5000);
    } finally {
      setIsSavingFeedback(false);
    }
  };

  const totalIssues = typeof summary.total_issues === 'number' ? summary.total_issues : issues.length;
  const hasUnsavedChanges = Object.values(unsavedIssues).some(Boolean);
  const followupCount =
    typeof summary.followup_count === 'number'
      ? summary.followup_count
      : issues.filter((issue) => Array.isArray(issue.followup) && issue.followup.length > 0).length;
  const categoryChips =
    summary.categories && typeof summary.categories === 'object'
      ? Object.entries(summary.categories)
      : categoryEntries.map(([category, list]) => [category, list.length] as [string, number]);

  if (categoryEntries.length === 0) {
    return (
      <>
        <Box
          sx={{
            border: '1px solid #e5e7eb',
            borderRadius: '10px',
            background: '#fafafa',
            p: 2,
            display: 'grid',
            gap: '8px',
            marginBottom: '30px',
          }}
        >
          <Box sx={{ fontSize: '16px', fontWeight: 700, color: '#111827' }}>AI Analysis Complete</Box>
          <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '13px', color: '#4b5563' }}>
            <span>Total Issues: {totalIssues}</span>
            <span>Follow-up Count: {followupCount}</span>
          </Box>
        </Box>
        <Box sx={{ fontSize: '14px', color: '#9ca3af', textAlign: 'center', py: 4 }}>No issues found in AI check.</Box>
      </>
    );
  }

  return (
    <>
      <Box
        sx={{
          border: '1px solid #e5e7eb',
          borderRadius: '10px',
          background: '#fafafa',
          p: 2,
          display: 'grid',
          gap: '8px',
          marginBottom: '30px',
        }}
      >
        <Box sx={{ fontSize: '16px', fontWeight: 700, color: '#111827' }}>AI Analysis Complete</Box>
        <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '13px', color: '#4b5563' }}>
          <span>Total Issues: {totalIssues}</span>
          <span>Follow-up Count: {followupCount}</span>
        </Box>
        {categoryChips.length > 0 && (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {categoryChips.map(([category, count]) => (
              <Box
                key={category}
                sx={{
                  border: '1px solid #dbe3f0',
                  background: '#ffffff',
                  borderRadius: '999px',
                  px: 1.5,
                  py: 0.5,
                  fontSize: '12px',
                  color: '#374151',
                  fontWeight: 600,
                }}
              >
                {category} ({String(count)})
              </Box>
            ))}
          </Box>
        )}
        <Box
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            color: '#3a3a3a',
            background: '#ffffff',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            px: 1.5,
            py: 1,
          }}
        >
          <strong>Note:</strong> Save records the feedback for all issues identified in this panel. It does not apply any automatic corrections to the HTML template.
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '30px', pr: 0.5, pb: '70px' }}>
        {categoryEntries.map(([category, list]) => {
          const count = list.length;
          const isOpen = openCategories[category] !== false;

          return (
            <Box
              key={category}
              ref={(el: HTMLDivElement | null) => { categoryRefs.current[category] = el; }}
              sx={{
                border: '1px solid #e5e7eb',
                borderRadius: '10px',
                background: '#ffffff',
                overflow: 'hidden',
              }}
            >
              <Box
                component="button"
                type="button"
                onClick={() => toggleCategory(category)}
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  background: '#fafafa',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '12px 14px',
                  fontWeight: 700,
                  fontSize: '14px',
                  color: '#111827',
                  textAlign: 'left',
                  '&:hover': { background: '#f3f4f6' },
                }}
              >
                <span>{category} ({count})</span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    display: 'inline-block',
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.15s ease',
                    color: '#6b7280',
                  }}
                >
                  <path
                    d="M2.33325 4.66675L5.99992 8.33341L9.66659 4.66675"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Box>
              {isOpen && (
                <Box
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                  }}
                >
                  {list.map((iss, idx) => {
                    const issueKey = `${category}-${iss.label ?? 'issue'}-${String(idx)}`;
                    const visibleFollowups = Array.isArray(iss.followup)
                      ? iss.followup
                          .map((fu, fIdx) => ({ fu, fIdx }))
                          .filter(({ fu }) => !isSuppressedFollowupItem(fu))
                      : [];

                    return (
                      <Box
                        key={issueKey}
                        sx={{
                          border: '1px solid #e5e7eb',
                          borderRadius: '10px',
                          background: '#ffffff',
                          p: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '12px',
                        }}
                      >
                        <Box sx={{ display: 'grid', gap: '12px' }}>
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                            <Box sx={{ width: '45%', fontSize: '14px', fontWeight: 600, color: '#3a3a3a' }}>
                              Label
                            </Box>
                            <BootstrapTooltip title={iss.label ?? ''}>
                              <Box sx={{ width: '55%', fontSize: '14px', color: '#3a3a3a', fontWeight: 500, wordBreak: 'break-word' }}>
                                {iss.label ?? ''}
                              </Box>
                            </BootstrapTooltip>
                          </Box>

                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                            <Box sx={{ width: '45%', fontSize: '14px', fontWeight: 600, color: '#3a3a3a' }}>
                              Description
                            </Box>
                            <BootstrapTooltip title={sanitizeAiPanelText(iss.description ?? '')}>
                              <Box
                                sx={{
                                  width: '55%',
                                  fontSize: '14px',
                                  color: '#3a3a3a',
                                  lineHeight: 1.6,
                                  wordBreak: 'break-word',
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                {sanitizeAiPanelText(iss.description ?? '')}
                              </Box>
                            </BootstrapTooltip>
                          </Box>

                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px', mb: 1 }}>
                            <Box sx={{ width: '45%', fontSize: '14px', fontWeight: 600, color: '#3a3a3a' }}>
                              Location
                            </Box>
                            <BootstrapTooltip title={getIssueLocationLabel(iss.location)}>
                              <Box sx={{ width: '55%', fontSize: '14px', color: '#3a3a3a', wordBreak: 'break-word' }}>
                                {getIssueLocationLabel(iss.location)}
                              </Box>
                            </BootstrapTooltip>
                          </Box>
                        </Box>

                        {visibleFollowups.length > 0 && (
                          <Box
                            sx={{
                              border: '1px solid #e0e7ff',
                              borderRadius: '8px',
                              background: '#fafafa',
                              p: 2,
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '12px',
                            }}
                          >
                            {visibleFollowups.map(({ fu, fIdx }) => {
                              const responseKey = `${issueKey}::${String(fIdx)}`;
                              const followupType = (fu.type ?? '').toLowerCase();
                              const initialFollowupValue = getFollowupStoredValue(fu);
                              const hasUserEditedValue = Object.prototype.hasOwnProperty.call(followupResponses, responseKey);
                              const selectedValue = hasUserEditedValue ? followupResponses[responseKey] : initialFollowupValue;

                              if (followupType === 'instruction') {
                                return (
                                  <Box
                                    key={responseKey}
                                    sx={{
                                      border: '1px solid #fed7aa',
                                      background: '#fff7ed',
                                      borderRadius: '8px',
                                      p: 1.5,
                                      fontSize: '13px',
                                      color: '#9a3412',
                                      fontWeight: 500,
                                    }}
                                  >
                                    {sanitizeAiPanelText(fu.text ?? '')}
                                  </Box>
                                );
                              }

                              if (followupType === 'textbox') {
                                return (
                                  <Box key={responseKey} sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <Box
                                      sx={{
                                        width: '100%',
                                        fontSize: '14px',
                                        color: '#3a3a3a',
                                        fontWeight: 600,
                                        lineHeight: 1.35,
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word',
                                        overflowWrap: 'anywhere',
                                      }}
                                    >
                                      {sanitizeAiPanelText(fu.text ?? '')}
                                    </Box>
                                    <Box
                                      component="input"
                                      type="text"
                                      value={selectedValue}
                                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleFollowupChange(responseKey, event.target.value)}
                                      placeholder="Enter value..."
                                      sx={{
                                        width: '100%',
                                        boxSizing: 'border-box',
                                        border: '1px solid #e6ecf2',
                                        borderRadius: '8px',
                                        px: 1.5,
                                        py: 1,
                                        fontSize: '14px',
                                        fontFamily: 'Manrope, sans-serif',
                                        color: '#3a3a3a',
                                        outline: 'none',
                                        background: '#ffffff',
                                        '&:focus': {
                                          borderColor: '#D6242C',
                                          boxShadow: '0 0 0 2px rgba(214, 36, 44, 0.12)',
                                        },
                                      }}
                                    />
                                  </Box>
                                );
                              }

                              if (followupType === 'radio' && Array.isArray(fu.options) && fu.options.length > 0) {
                                return (
                                  <Box key={responseKey} sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <Box
                                      sx={{
                                        width: '100%',
                                        fontSize: '14px',
                                        color: '#3a3a3a',
                                        fontWeight: 600,
                                        lineHeight: 1.35,
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word',
                                        overflowWrap: 'anywhere',
                                      }}
                                    >
                                      {sanitizeAiPanelText(fu.text ?? '')}
                                    </Box>
                                    <RadioGroup
                                      value={selectedValue}
                                      onChange={(event) => { handleFollowupChange(responseKey, event.target.value); }}
                                      sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        flexWrap: 'nowrap',
                                        alignItems: 'center',
                                        gap: '14px',
                                      }}
                                    >
                                      {fu.options.map((opt, optionIdx) => {
                                        const optionValue = String(opt ?? '').trim();
                                        return (
                                          <FormControlLabel
                                            key={`${responseKey}-${String(optionIdx)}`}
                                            value={optionValue}
                                            control={
                                              <Radio
                                                sx={{
                                                  color: '#9ca3af',
                                                  '&.Mui-checked': {
                                                    color: '#D6242C',
                                                  },
                                                }}
                                              />
                                            }
                                            label={friendlyOption(optionValue)}
                                            sx={{
                                              m: 0,
                                              px: 0,
                                              py: 0,
                                              '& .MuiTypography-root': {
                                                fontFamily: 'Manrope, sans-serif',
                                              },
                                              '& .MuiFormControlLabel-label': {
                                                color: '#3A3A3A',
                                                fontSize: '14px',
                                              },
                                            }}
                                          />
                                        );
                                      })}
                                    </RadioGroup>
                                  </Box>
                                );
                              }

                              return null;
                            })}
                          </Box>
                        )}

                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>
          );
        })}
      </Box>

      <div className="grid grid-cols-6 gap-0 fixed bottom-0 left-0 right-0 z-10 bg-white overflow-x-hidden">
        <div className="w-full relative col-span-3">
          <button
            type="button"
            className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
            onClick={onClosePanel}
            disabled={isSavingFeedback}
          >
            Cancel
          </button>
        </div>
        <div className="w-full relative col-span-3">
          <button
            type="button"
            onClick={() => { void handleFixIssue(); }}
            disabled={isSavingFeedback || !hasUnsavedChanges}
            className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
          >
            {!isSavingFeedback ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}
          </button>
        </div>
      </div>
    </>
  );
};

function CustomEditor({
  onHtmlChange,
  onDirtyCheckChange,
  initialHtml,
  onImageUpload,
  editorRef: externalEditorRef,
  onSendTestEmail,
  isEditPage,
  templateIdentifier,
  templateName,
}: TemplateEditorProps): JSX.Element {
  const internalEditorRef = useRef(null);
  const editorRef = externalEditorRef ?? internalEditorRef;

  const [viewMode, setViewMode] = useState<'preview' | 'code'>(isEditPage ? 'preview' : 'code');
  const [code, setCode] = useState<string>(initialHtml ?? '');
  const [isDirtyCheck, setIsDirtyCheck] = useState<boolean>(false);
  const [openAIPanel, setOpenAIPanel] = useState<boolean>(false);
  const initialCodeRef = useRef<string>(initialHtml ?? '');
  const isInternalContentUpdateRef = useRef<boolean>(false);

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isInsertingTagRef = useRef(false);

  type AIStatus = 'idle' | 'waking' | 'submitting' | 'polling' | 'fetching' | 'done' | 'error';
  const [aiStatus, setAiStatus] = useState<AIStatus>('idle');
  const [aiError, setAiError] = useState<string>('');
  const [aiJobId, setAiJobId] = useState<string>('');
  const [aiTransactionId, setAiTransactionId] = useState<string>('');
  const [aiJobStatus, setAiJobStatus] = useState<string>('');
  const [aiDetails, setAiDetails] = useState<any>(null);
  const aiPollRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const aiCancelledRef = useRef<boolean>(false);
  const aiPollAttemptsRef = useRef<number>(0);
  const AI_POLL_INTERVAL_MS = 2500;
  const AI_POLL_MAX_ATTEMPTS_WITHOUT_SUCCESS = 5;

  const composedTemplateId =
    templateIdentifier != null && templateIdentifier !== ''
      ? String(templateIdentifier)
      : '';

  useEffect(() => {
    if (aiStatus === 'error') {
      console.log('error', aiError);
      NotificationManager.error(aiError || UNKNOWN_ERR);
    }
  }, [aiStatus, aiError]);

  const resetAiState = (): void => {
    if (aiPollRef.current) {
      clearTimeout(aiPollRef.current);
      aiPollRef.current = null;
    }
    aiCancelledRef.current = false;
    aiPollAttemptsRef.current = 0;
    setAiStatus('idle');
    setAiError('');
    setAiJobId('');
    setAiTransactionId('');
    setAiJobStatus('');
    setAiDetails(null);
  };

  const extractValidationJobId = (raw: any): string => {
    const payload = raw?.data ?? raw ?? {};
    const candidates = [
      payload?.data?.result?.data?.jobId,
      payload?.data?.result?.data?.job_id,
      payload?.data?.result?.jobId,
      payload?.data?.result?.job_id,
      payload?.result?.data?.jobId,
      payload?.result?.data?.job_id,
      payload?.result?.jobId,
      payload?.result?.job_id,
      payload?.data?.jobId,
      payload?.data?.job_id,
      payload?.jobId,
      payload?.job_id,
    ];

    for (const candidate of candidates) {
      if (typeof candidate === 'string' && candidate.trim() !== '') {
        return candidate;
      }
    }

    return '';
  };

  const extractValidationTransactionId = (raw: any): string => {
    const payload = raw?.data ?? raw ?? {};
    const candidates = [
      payload?.data?.result?.data?.transactionId,
      payload?.data?.result?.data?.transaction_id,
      payload?.data?.result?.transactionId,
      payload?.data?.result?.transaction_id,
      payload?.result?.data?.transactionId,
      payload?.result?.data?.transaction_id,
      payload?.result?.transactionId,
      payload?.result?.transaction_id,
      payload?.data?.transactionId,
      payload?.data?.transaction_id,
      payload?.transactionId,
      payload?.transaction_id,
    ];

    for (const candidate of candidates) {
      if (typeof candidate === 'string' && candidate.trim() !== '') {
        return candidate;
      }
    }

    return '';
  };

  const hasValidationDataKey = (raw: any): boolean => {
    const payload = raw?.data ?? null;
    return payload != null && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'data');
  };

  const extractValidationDisplayData = (raw: any): any => {
    if (!hasValidationDataKey(raw)) return null;
    return raw?.data?.data ?? null;
  };

  const submitAiValidationJob = async (): Promise<string | null> => {
    setAiStatus('waking');
    try { await aiValidationWakeup(); } catch { /* wakeup is best-effort */ }
    if (aiCancelledRef.current) return null;

    setAiStatus('submitting');
    const apiBase = (process.env.REACT_APP_API_BASE_URL ?? '').replace(/\/+$/, '');
    const callbackUrl = `${apiBase}/template/aivalidation/webhooks/validationdetails`;
    console.log(`[AI Validation] Submitting validation request to ${apiBase}`);
    const submitRes: any = await aiValidationValidateHtml({
      task: 'validate_html',
      html: code,
      templateId: composedTemplateId,
      callbackUrl,
      createdBy: getCurrentLoggedInUserId(),
    });
    console.log(`[AI Validation] Submit response:`, submitRes);
    if (aiCancelledRef.current) return null;

    const payload = submitRes?.data?.data ?? submitRes?.data ?? {};
    console.log(`[AI Validation] Extracted payload:`, payload);
    const submitTransactionId = extractValidationTransactionId(submitRes);
    if (submitTransactionId !== '') {
      setAiTransactionId(submitTransactionId);
    }

    const jobId: string =
      payload?.jobId ??
      payload?.job_id ??
      payload?.id ??
      payload?.taskId ??
      payload?.task_id ??
      (typeof payload === 'string' ? payload : '') ??
      '';

    console.log(`[AI Validation] Extracted jobId: ${jobId}`);
    if (!jobId) {
      console.warn('AI validation submit response:', submitRes?.data);
      setAiStatus('error');
      setAiError('No jobId returned from AI validation service.');
      return null;
    }

    setAiJobId(jobId);
    return jobId;
  };

  const pollJob = async (jobId: string): Promise<void> => {
    try {
      if (aiCancelledRef.current) {
        console.log(`[AI Validation] Poll cancelled, skipping job: ${jobId}`);
        return;
      }
      console.log(`[AI Validation] Polling job: ${jobId}`);
      console.log(`[AI Validation] About to call aiValidationGetDetails...`);
      const res: any = await aiValidationGetDetails(composedTemplateId);
      console.log(`[AI Validation] Job response received:`, res);
      if (aiCancelledRef.current) return;
      const responseJobId = extractValidationJobId(res);
      if (responseJobId !== '') {
        setAiJobId(responseJobId);
      }
      const responseTransactionId = extractValidationTransactionId(res);
      if (responseTransactionId !== '') {
        setAiTransactionId(responseTransactionId);
      }
      const data = res?.data?.data ?? {};
      const hasDataKey = hasValidationDataKey(res);
      const nextJobId = responseJobId || jobId;

      if (hasDataKey) {
        aiPollAttemptsRef.current = 0;
        setAiStatus('done');
        setAiDetails(extractValidationDisplayData(res));
        initialCodeRef.current = code;
        setIsDirtyCheck(false);
        return;
      }

      if (!hasDataKey) {
        aiPollAttemptsRef.current += 1;
        console.log(
          `[AI Validation] Data key not found in ValidationDetails response. Attempt ${String(aiPollAttemptsRef.current)}/${String(AI_POLL_MAX_ATTEMPTS_WITHOUT_SUCCESS)}`,
        );
      }

      const status: string = (data?.status ?? data?.state ?? '').toString().toLowerCase();
      console.log(`[AI Validation] Job status: ${status}`);
      setAiJobStatus(status || 'processing');

      const isFailed = ['failed', 'error', 'cancelled', 'canceled'].includes(status);

      if (isFailed) {
        aiPollAttemptsRef.current = 0;
        setAiStatus('error');
        setAiError(data?.error?.message ?? data?.message ?? data?.error ?? 'AI validation job failed.');
        return;
      }

      if (aiPollAttemptsRef.current >= AI_POLL_MAX_ATTEMPTS_WITHOUT_SUCCESS) {
        console.log('[AI Validation] Max ValidationDetails retries reached without data key. Re-submitting validation job.');
        aiPollAttemptsRef.current = 0;
        const restartedJobId = await submitAiValidationJob();
        if (aiCancelledRef.current || !restartedJobId) return;
        setAiStatus('polling');
        aiPollRef.current = setTimeout(() => { void pollJob(restartedJobId); }, AI_POLL_INTERVAL_MS);
        return;
      }

      console.log(`[AI Validation] Setting poll timeout for next check in 2.5s`);
      aiPollRef.current = setTimeout(() => { void pollJob(nextJobId); }, AI_POLL_INTERVAL_MS);
    } catch (err: any) {
      console.error(`[AI Validation] Poll error:`, err);
      if (aiCancelledRef.current) return;

      if (isTransientValidationDetailsError(err)) {
        setAiJobStatus('processing');
        aiPollAttemptsRef.current += 1;

        if (aiPollAttemptsRef.current >= AI_POLL_MAX_ATTEMPTS_WITHOUT_SUCCESS) {
          console.log('[AI Validation] Max transient poll retries reached. Re-submitting validation job.');
          aiPollAttemptsRef.current = 0;
          const restartedJobId = await submitAiValidationJob();
          if (aiCancelledRef.current || !restartedJobId) return;
          setAiStatus('polling');
          aiPollRef.current = setTimeout(() => { void pollJob(restartedJobId); }, AI_POLL_INTERVAL_MS);
          return;
        }

        aiPollRef.current = setTimeout(() => { void pollJob(jobId); }, AI_POLL_INTERVAL_MS);
        return;
      }

      aiPollAttemptsRef.current = 0;
      setAiStatus('error');
      setAiError(err?.response?.data?.message ?? err?.message ?? 'Failed to poll AI validation job.');
    }
  };

  const runAiValidation = async (): Promise<void> => {
    aiCancelledRef.current = false;
    aiPollAttemptsRef.current = 0;
    setAiError('');
    setAiDetails(null);
    setAiJobId('');
    setAiTransactionId('');
    setAiJobStatus('');

    const normalizedHtml = code.trim();
    if (normalizedHtml === '') {
      setAiStatus('error');
      setAiError(HTML_REQUIRED_MESSAGE);
      return;
    }

    try {
      let detailsRes: any = null;

      try {
        setAiStatus('fetching');
        detailsRes = await aiValidationGetDetails(composedTemplateId);
        if (aiCancelledRef.current) return;
      } catch (detailsErr: unknown) {
        if (!isTransientValidationDetailsError(detailsErr)) {
          throw detailsErr;
        }
      }

      const initialDetailsJobId = extractValidationJobId(detailsRes);
      if (initialDetailsJobId !== '') {
        setAiJobId(initialDetailsJobId);
      }
      const initialDetailsTransactionId = extractValidationTransactionId(detailsRes);
      if (initialDetailsTransactionId !== '') {
        setAiTransactionId(initialDetailsTransactionId);
      }

      const hasInitialDataKey = hasValidationDataKey(detailsRes);

      if (!isDirtyCheck && hasInitialDataKey) {
        const detailsPayload = detailsRes?.data?.data ?? {};
        const detailsStatus: string = (detailsPayload?.status ?? detailsPayload?.state ?? '').toString().toLowerCase();
        setAiStatus('done');
        setAiJobStatus(detailsStatus || 'completed');
        setAiDetails(extractValidationDisplayData(detailsRes));
        initialCodeRef.current = code;
        setIsDirtyCheck(false);
        return;
      }

      if (isDirtyCheck) {
        const jobId = await submitAiValidationJob();
        if (aiCancelledRef.current || !jobId) return;

        console.log(`[AI Validation] Starting to poll job: ${jobId}`);
        setAiStatus('polling');
        void pollJob(jobId);
        return;
      }

      setAiStatus('polling');
      void pollJob(initialDetailsJobId);
      return;
    } catch (err: any) {
      setAiStatus('error');
      setAiError(err?.response?.data?.message ?? err?.message ?? 'Failed to start AI validation.');
    }
  };

  const handleOpenAIPanel = (): void => {
    setOpenAIPanel(true);
    resetAiState();
    void runAiValidation();
  };
  const handleCloseAIPanel = (): void => {
    aiCancelledRef.current = true;
    if (aiPollRef.current) {
      clearTimeout(aiPollRef.current);
      aiPollRef.current = null;
    }
    setOpenAIPanel(false);
  };

  useEffect(() => {
    return () => {
      aiCancelledRef.current = true;
      if (aiPollRef.current) clearTimeout(aiPollRef.current);
    };
  }, []);

  // Initialize code with initialHtml when component mounts or when initialHtml changes
  useEffect(() => {
    const nextInitialHtml = initialHtml ?? '';

    // Ignore parent echo updates triggered by this editor's own onHtmlChange callback.
    if (isInternalContentUpdateRef.current) {
      isInternalContentUpdateRef.current = false;
      setCode(nextInitialHtml);
      return;
    }

    initialCodeRef.current = nextInitialHtml;
    setCode(nextInitialHtml);
    setIsDirtyCheck(false);
  }, [initialHtml]);

  const updateContent = (value: string): void => {
    isInternalContentUpdateRef.current = true;
    setCode(value);
    onHtmlChange(value);
    setIsDirtyCheck(value !== initialCodeRef.current);
  };

  useEffect(() => {
    onDirtyCheckChange?.(isDirtyCheck);
  }, [isDirtyCheck, onDirtyCheckChange]);

// Helper function to get full HTML document with updated body content
const getFullHtmlWithUpdatedBody = (newBodyContent: string): string => {
  const hasHtmlStructure = /<(!DOCTYPE|html|head|body)/i.test(code);
  
  if (!hasHtmlStructure) {
    // If original code doesn't have HTML structure, return just the content
    return newBodyContent;
  }

  // Replace the body content while preserving everything else
  return code.replace(
    /(<body[^>]*>)([\s\S]*?)(<\/body>)/i,
    `$1${newBodyContent}$3`
  );
};

useEffect(() => {
  if (viewMode === 'preview' && iframeRef.current) {
    const doc = iframeRef.current.contentDocument;
    const win = iframeRef.current.contentWindow;
    if (!doc || !win) return;

    const style = `
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 16px;
          outline: none;
        }
        .brace {
          font-weight: bold;
          user-select: none;
          font-family: monospace;
          background: linear-gradient(90deg, 
            #007bff 0ch, #007bff 2ch, 
            #000 2ch, #000 calc(100% - 2ch), 
            #007bff calc(100% - 2ch), #007bff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        @supports not (-webkit-background-clip: text) {
          .brace {
            color: #000;
          }
        }
      </style>
    `;

    const hasHtmlStructure = /<(!DOCTYPE|html|head|body)/i.test(code);
    
    if (!doc.body || doc.body.innerHTML === '') {
       doc.open();

      if (hasHtmlStructure) {
        const htmlWithStyles = code.replace(
          /(<head[^>]*>)/i,
          `$1${style}`
        ).replace(
          /(<body[^>]*)/i,
          `$1 contenteditable="true"`
        );
        (doc as any).write(htmlWithStyles);
      } else {
        (doc as any).write(`<html><head>${style}</head><body contenteditable="true">${code}</body></html>`);
      }

       doc.close();

    }
    // Remove the automatic content sync that was causing issues

    const body = doc.body;
    if (!body) return;
    // ✅ Only update <img> src values instead of replacing whole body
    const newDoc = document.createElement("html");
    newDoc.innerHTML = code;
    const newImages = newDoc.querySelectorAll("img");
    const currentImages = body.querySelectorAll("img");

    newImages.forEach((newImg, idx) => {
      const currentImg = currentImages[idx];
      if (currentImg && currentImg.src !== newImg.src) {
        currentImg.src = newImg.src;
      }
    });

    // Only listen to user input changes, not programmatic changes
    const handleInput = (): void => {
      if (!isInsertingTagRef.current) {
        const newBodyContent = body.innerHTML;
        const fullHtml = getFullHtmlWithUpdatedBody(newBodyContent);
        updateContent(fullHtml);
      }
    };
    
    body.addEventListener('input', handleInput);

    return () => {
      body.removeEventListener('input', handleInput);
    };
  }
}, [viewMode, code, onHtmlChange]);

const insertMergeTagInIframe = (tag: string): void => {
  const iframeDoc = iframeRef.current?.contentDocument;
  const iframeWin = iframeRef.current?.contentWindow;
  if (!iframeDoc || !iframeWin) return;

  const body = iframeDoc.body;
  if (!body) return;

  isInsertingTagRef.current = true;
  body.focus();

  const span = iframeDoc.createElement('span');
  span.className = 'brace';
  span.contentEditable = 'false';

  const inner = tag.replace(/[{}]/g, '').trim();
  span.textContent = `{{${inner}}}`;

  const sel = iframeWin.getSelection();
  let range = sel?.rangeCount ? sel.getRangeAt(0) : null;

  if (!range || !body.contains(range.startContainer)) {
    range = iframeDoc.createRange();
    range.selectNodeContents(body);
    range.collapse(false);
    sel?.removeAllRanges();
    sel?.addRange(range);
  }

  try {
    range.deleteContents();
    range.insertNode(span);

    const cursor = iframeDoc.createRange();
    cursor.setStartAfter(span);
    cursor.collapse(true);
    sel?.removeAllRanges();
    sel?.addRange(cursor);

    requestAnimationFrame(() => {
      const newBodyContent = body.innerHTML;
      const fullHtml = getFullHtmlWithUpdatedBody(newBodyContent);
      updateContent(fullHtml);
      isInsertingTagRef.current = false;
      body.focus();
    });
  } catch (err) {
    console.error('Error inserting merge tag:', err);
    isInsertingTagRef.current = false;
  }
};
  const handleUploadImages = (): void => {
    if (onImageUpload) {
      onImageUpload();
    }
  };

  const handleSendTestEmail = (): void => {
    if (onSendTestEmail) {
      onSendTestEmail();
    }  
  };


  
  const insertAtCursor = (text: string): void => {
    const view = editorRef.current?.view;
    if (!view) return;

    const { from } = view.state.selection.main;
    const to = from + text.length;

    view.dispatch({
      changes: { from, insert: text },
      selection: { anchor: to },
    });

    view.focus();
  };

  useEffect(() => {
    const view = editorRef.current?.view;

    const handlePaste = (event: ClipboardEvent): void => {
      const pastedText = event.clipboardData?.getData('text/plain');
      if (pastedText != null && /<\/?[a-z][\s\S]*>/i.test(pastedText)) {
        event.preventDefault();
        const beautified = beautifyHtml(pastedText, {
          indent_size: 2,
          wrap_line_length: 120,
        });
        insertAtCursor(beautified);
      }
    };

    if (view?.dom) {
      view.dom.addEventListener('paste', handlePaste);
    }

    return () => {
      if (view?.dom) {
        view.dom.removeEventListener('paste', handlePaste);
      }
    };
  }, [editorRef]);

  const debouncedSetCode = useRef(
    debounce((val: string) => {
      updateContent(val);
    }, 200),
  ).current;

  const isCheckWithAiDisabled = code.trim() === '';

  console.log("isEditPage", isEditPage);
  console.log("isDirtyCheck",isDirtyCheck);
  
  return (
    <React.Fragment>
      <div style={{ fontFamily: 'Manrope, sans-serif' }}>
        {/* Unified Toolbar Line */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '8px',
            flexWrap: 'wrap',
            gap: '10px',
            fontFamily: 'Manrope, sans-serif',
          }}
        >
          {/* Left Section: Toggle + Merge Tags + Send Test */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              flexWrap: 'wrap',
            }}
          >
            {/* Toggle Buttons */}
            <div
              style={{
                display: 'flex',
                background: '#f5f5f5',
                borderRadius: '999px',
                width: '150px'
              }}
            >
              <button
                onClick={() => setViewMode('preview')}
                type='button'
                style={{
                  flex: 1,
                  padding: '8px 0',
                  border: 'none',
                  borderRadius: '999px',
                  color:'#3a3a3a',
                  backgroundColor:
                    viewMode === 'preview' ? '#fff' : ' #F5F5F5',
                  fontWeight: viewMode === 'preview' ? 600 : 400,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow:
                    viewMode === 'preview'
                      ? '0 1px 3px rgba(0,0,0,0.1)'
                      : 'none',
                }}
              >
                Preview
              </button>
              <button
                onClick={() => setViewMode('code')}
                type='button'
                style={{
                  flex: 1,
                  padding: '8px 0',
                  border: 'none',
                  color:'#3a3a3a',
                  borderRadius: '999px',
                  backgroundColor: viewMode === 'code' ? '#fff' : ' #F5F5F5',
                  fontWeight: viewMode === 'code' ? 600 : 400,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow:
                    viewMode === 'code' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}
              >
                Code
              </button>
            </div>

            {/* Check with AI */}
            <Box
              component="button"
              type="button"
              disabled={isCheckWithAiDisabled}
              onClick={handleOpenAIPanel}
              id="check-with-ai"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                background: 'linear-gradient(90deg, #ff4d4f 0%, #d9363e 100%)',
                color: '#fff',
                border: 'none',
                cursor: isCheckWithAiDisabled ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                padding: '6px 14px',
                borderRadius: '999px',
                boxShadow: '0 1px 3px rgba(217, 54, 62, 0.35)',
                transition: 'all 0.2s ease',
                opacity: isCheckWithAiDisabled ? 0.55 : 1,
                '&:hover': {
                  background: isCheckWithAiDisabled
                    ? 'linear-gradient(90deg, #ff4d4f 0%, #d9363e 100%)'
                    : 'linear-gradient(90deg, #ff3b3d 0%, #c02a32 100%)',
                  boxShadow: isCheckWithAiDisabled
                    ? '0 1px 3px rgba(217, 54, 62, 0.35)'
                    : '0 2px 6px rgba(217, 54, 62, 0.45)',
                },
              }}
            >
              Check with AI
            </Box>

             {/* Send Test Email */}
             {(isEditPage
  ? checkEventPermission("TEMPLATE_UPDATE")
  : checkEventPermission("TEMPLATE_ADD")) && (
  <div className="icon-hover-container">
    <BootstrapTooltip title={SEND_TEST_EMAIL}>
      <IconButton onClick={handleSendTestEmail}>
        <HugeiconsIcon
          icon={MailSend02Icon}
          size={24}
          strokeWidth={0.2}
          color="#3a3a3a"
        />
      </IconButton>
    </BootstrapTooltip>
  </div>
)}

<MergeTagsDropdown insertAtCursor={viewMode === 'code' ? insertAtCursor : insertMergeTagInIframe} viewMode={viewMode} />

            {viewMode === 'code' && (
              <>
                <Box
                  onClick={() => {
                    const beautified = beautifyHtml(code, {
                      indent_size: 2,
                      wrap_line_length: 120,
                    });
                    updateContent(beautified);
                  }}
                  sx={{
                    color: '#3a3a3a',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    '&:hover': {
                      backgroundColor: '#fafafa',
                    },
                  }}
                  id='format-code'
                >
                  Format Code
                </Box>
              </>
            )}
          </div>

          {(isEditPage
            ? checkEventPermission("TEMPLATE_UPDATE")
            : checkEventPermission("TEMPLATE_ADD")) && 
            
          <Box
            onClick={handleUploadImages}
            sx={{              
              color: '#7869E',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              padding: '4px 8px',
              borderRadius: '4px',
              '&:hover': {
                backgroundColor: '#fafafa',
              },
            }}
            id='upload-images'
          >
            {'Upload Images ->'}
          </Box>
         
          }
        </div>

        {/* Content Based on View */}
        {viewMode === 'code' ? (
          <div
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              overflow: 'hidden',
            }}
          >
            <CodeMirror
              value={code}
              height="70vh"
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call
              extensions={[html()]}
              onChange={(value) => debouncedSetCode(value)}
              placeholder="Type your HTML here..."
              theme="light"
              ref={editorRef}
              style={{ fontSize: '14px' }}
            />
          </div>
        ) : (
          <div
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              overflow: 'hidden',
              height: '70vh',
            }}
          >
            <iframe
              ref={iframeRef}
              title="Live Preview"
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          </div>
        )}
      </div>

      <MUIModal
        title="AI Check Results"
        openModal={openAIPanel}
        closeModal={handleCloseAIPanel}
      >
        <Box
          sx={{
            pt: '10px',
            px: '16px',
            pb: 0,
            fontFamily: 'Manrope, sans-serif',
            color: '#3a3a3a',
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
            height: '100%',
            overflow: 'auto',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '14px', flexShrink: 0 }}>
            <Box className="w-full relative role-input-container disabled" sx={{ marginBottom: '30px' }}>
              <TextField
                id="ai-template-name"
                label={'Template Name'}
                variant="outlined"
                fullWidth
                value={templateName ?? ''}
                autoComplete="off"
                InputProps={{
                  style: {
                    textAlign: 'center',
                    color: '#343434',
                    fontSize: '18px',
                    fontWeight: 700,
                    WebkitTextFillColor: '#343434',
                    padding: '9px 14px 9px 25px',
                  },
                }}
                sx={{
                  '& input': {
                    textAlign: 'center',
                  },
                  '& label': {
                    textAlign: 'center',
                  },
                  backgroundColor: '#F5F5F5',
                }}
                disabled={true}
              />
            </Box>
          </Box>

          {(aiStatus === 'waking' ||
            aiStatus === 'submitting' ||
            aiStatus === 'polling' ||
            aiStatus === 'fetching') && (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
                fontSize: '14px',
                color: '#3a3a3a',
              }}
            >
              <span className="loading loading-spinner text-primary"  />
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                <Box sx={{ fontWeight: 700, letterSpacing: '0.5px' }}>ANALYZING...</Box>
                <Box sx={{ fontSize: '13px', color: '#6b7280' }}>
                  Analyzing template{aiJobStatus ? ` (${aiJobStatus})` : ''}...
                </Box>
              </Box>
            </Box>
          )}

          {aiStatus === 'done' && (
            <Box
              sx={{
                fontSize: '13px',
              }}
            >
                {aiDetails == null ? (
                  <>
                    <Box
                      sx={{
                        border: '1px solid #e5e7eb',
                        borderRadius: '10px',
                        background: '#fafafa',
                        p: 2,
                        display: 'grid',
                        gap: '8px',
                        marginBottom: '30px',
                      }}
                    >
                      <Box sx={{ fontSize: '16px', fontWeight: 700, color: '#111827' }}>AI Analysis Complete</Box>
                      <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '13px', color: '#4b5563' }}>
                        <span>Total Issues: 0</span>
                        <span>Follow-up Count: 0</span>
                      </Box>
                      <Box
                        sx={{
                          fontSize: '14px',
                          fontWeight: 400,
                          color: '#3a3a3a',
                          background: '#ffffff',
                          border: '1px solid #e5e7eb',
                          borderRadius: '8px',
                          px: 1.5,
                          py: 1,
                        }}
                      >
                        No issues found in AI check.
                      </Box>
                    </Box>
                  </>
                ) : typeof aiDetails === 'string' ? (
                  isNoValidationDetailsMessage(aiDetails) ? (
                    <>
                      <Box
                        sx={{
                          border: '1px solid #e5e7eb',
                          borderRadius: '10px',
                          background: '#fafafa',
                          p: 2,
                          display: 'grid',
                          gap: '8px',
                          marginBottom: '30px',
                        }}
                      >
                        <Box sx={{ fontSize: '16px', fontWeight: 700, color: '#111827' }}>AI Analysis Complete</Box>
                        <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '13px', color: '#4b5563' }}>
                          <span>Total Issues: 0</span>
                          <span>Follow-up Count: 0</span>
                        </Box>
                        <Box
                          sx={{
                            fontSize: '14px',
                            fontWeight: 400,
                            color: '#3a3a3a',
                            background: '#ffffff',
                            border: '1px solid #e5e7eb',
                            borderRadius: '8px',
                            px: 1.5,
                            py: 1,
                          }}
                        >
                          No issues found in AI check.
                        </Box>
                      </Box>
                    </>
                  ) : (
                    <Box sx={{ whiteSpace: 'pre-wrap' }}>{sanitizeAiPanelText(aiDetails)}</Box>
                  )
                ) : Array.isArray((aiDetails as any)?.issues) ? (
                  <AIResultsView details={aiDetails} templateUId={composedTemplateId} jobId={aiJobId} transactionId={aiTransactionId} onClosePanel={handleCloseAIPanel} />
                ) : (
                  <pre style={{ margin: 0, fontFamily: 'inherit', fontSize: '13px' }}>
                    {JSON.stringify(aiDetails, null, 2)}
                  </pre>
                )}
            </Box>
          )}
        </Box>
      </MUIModal>
    </React.Fragment>
  );
}

export default CustomEditor;